import CodeEditor from "components/CodeEditor";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type RuntimeConfigDetailsDrawerProps = {
  runtimeConfig?: string;
  customRuntimeConfig?: string;
};

const RuntimeConfigDetailsDrawer = createDrawer(
  ({ runtimeConfig, customRuntimeConfig }: RuntimeConfigDetailsDrawerProps) => (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Runtime config details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight gap="medium">
        {runtimeConfig && (
          <>
            <Typography tag="span" variant="p-t7">
              Runtime config
            </Typography>
            <Box direction="column" className={styles.codeEditorWrapper}>
              <CodeEditor
                body={runtimeConfig}
                language="yaml"
                readOnly
                rounded
                options={{ automaticLayout: true }}
              />
            </Box>
          </>
        )}
        {customRuntimeConfig && (
          <>
            <Typography tag="span" variant="p-t7" margin="large 0 0 0">
              Custom config
            </Typography>
            <Box direction="column" className={styles.codeEditorWrapper}>
              <CodeEditor
                className={styles.codeEditor}
                body={customRuntimeConfig}
                language="yaml"
                readOnly
                rounded
                options={{ automaticLayout: true }}
              />
            </Box>
          </>
        )}
      </DrawerBody>
    </DrawerSimple>
  )
);

export const showRuntimeConfigDetailsDrawer = createDrawerTrigger(RuntimeConfigDetailsDrawer);
